/* eslint-disable max-len */
import { HttpClient } from '@angular/common/http';
import { inject, Service, signal } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environment/environment';
import { BucketType } from '../../model/bucket-type.enum';
import { WebConfigService } from '../web-config/web-config.service';
import { ScriptLoader } from '../load-script';
import { WINDOW } from '../../providers/window/window.provider';
import * as PDFObject from 'pdfobject';

export type NdaDocumentUrlResponse = {
  presignedUrls: {
    haloNda: string;
  };
};

@Service()
export class DocumentsService {
  #http = inject(HttpClient);
  #webconfig = inject(WebConfigService);
  #window = inject(WINDOW);
  static haloNdaDocument = 'nda_halo_dot_synthesis.pdf';
  static haloDeveloperDocs = 'http://docs.halodot.io/';
  static haloGithubRepo = 'https://github.com/halodot/';
  static haloGoAndroidApp =
    'https://play.google.com/store/apps/details?id=za.co.synthesis.halo.mpos.go&pcampaignid=web_share';
  static termsAndConditionsUrl = `/assets/documents/terms_and_conditions.pdf`;
  static authScreenBackground = `${environment.baseUrls.static}/static/flavours/go/login/halo-slide-1.png`;
  scriptLoaded = signal(false);

  loadPdfObject(url: string): HTMLElement {
    const pdfObject = (this.#window as unknown as { PDFObject: typeof PDFObject }).PDFObject;
    return pdfObject.embed(url, '#pdf-container');
  }

  loadPdfObjectScript(): Promise<boolean> {
    if ((this.#window as unknown as { PDFObject: unknown }).PDFObject) {
      this.scriptLoaded.set(true);
      return Promise.resolve(true);
    }
    return ScriptLoader.loadScript('script', { src: 'https://unpkg.com/pdfobject', async: true }).then(() => {
      this.scriptLoaded.set(true);
      return true;
    });
  }

  getHaloNdaDocument(): Observable<Blob> {
    const queryParams = new URLSearchParams({ bucket: BucketType.Documents });
    const url = `${this.#webconfig.baseUrls.backend}/files/documents/${DocumentsService.haloNdaDocument}?${queryParams.toString()}`;
    return this.#http.get(url, { withCredentials: true, responseType: 'blob' });
  }

  getNdaDocumentUrl(): Observable<Blob> {
    const url = `/assets/documents/nda_halo_dot_synthesis.pdf`;
    return this.#http.get(url, { responseType: 'blob' });
  }
}
